import { getSlicePercentage } from './plot-data.utils.js';
import { ColorToken } from '../../core/types/color-palette.js';
import { InternalSliceData } from '../types/internal/pie-chart.js';

export const groupSlicesThinnerThanPadAngle = (
  slices: InternalSliceData[],
  padAngle: number,
): InternalSliceData[] => {
  let slicesThinnerThanPadAngleValueSum = 0;
  let totalAbsoluteValueSum = 0;
  const newSlices: InternalSliceData[] = [];
  const padAngleDeg = (padAngle * 180) / Math.PI;
  for (const slice of slices) {
    const sliceAngleDeg = (slice.relativeValue / 100) * 360;
    if (sliceAngleDeg <= padAngleDeg) {
      slicesThinnerThanPadAngleValueSum += slice.value;
    } else {
      newSlices.push(slice);
    }
    totalAbsoluteValueSum += slice.value;
  }
  if (slicesThinnerThanPadAngleValueSum > 0) {
    const negativeSlicesAggregatedSliceColorToken: ColorToken = {
      Default: 'transparent',
    };
    const negativeSlicesAggregatedSlice: InternalSliceData = {
      category: '',
      value: slicesThinnerThanPadAngleValueSum,
      color: negativeSlicesAggregatedSliceColorToken,
      id: 'thinner-slices',
      relativeValue: getSlicePercentage(
        slicesThinnerThanPadAngleValueSum,
        totalAbsoluteValueSum,
      ),
    };
    newSlices.push(negativeSlicesAggregatedSlice);
  }
  return newSlices;
};
